/**
 * Client-side localization for Bible book names.
 * Keys match the English book names as they appear in the loaded Bible JSON.
 * Used as a fallback/override so book names display correctly even before
 * a translated Bible version is downloaded.
 */

const BOOK_NAMES = {
  zh: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          '創世記',
    'Exodus':           '出埃及記',
    'Leviticus':        '利未記',
    'Numbers':          '民數記',
    'Deuteronomy':      '申命記',
    'Joshua':           '約書亞記',
    'Judges':           '士師記',
    'Ruth':             '路得記',
    '1 Samuel':         '撒母耳記上',
    '2 Samuel':         '撒母耳記下',
    '1 Kings':          '列王紀上',
    '2 Kings':          '列王紀下',
    '1 Chronicles':     '歷代志上',
    '2 Chronicles':     '歷代志下',
    'Ezra':             '以斯拉記',
    'Nehemiah':         '尼希米記',
    'Esther':           '以斯帖記',
    'Job':              '約伯記',
    'Psalms':           '詩篇',
    'Proverbs':         '箴言',
    'Ecclesiastes':     '傳道書',
    'Song of Solomon':  '雅歌',
    'Isaiah':           '以賽亞書',
    'Jeremiah':         '耶利米書',
    'Lamentations':     '耶利米哀歌',
    'Ezekiel':          '以西結書',
    'Daniel':           '但以理書',
    'Hosea':            '何西阿書',
    'Joel':             '約珥書',
    'Amos':             '阿摩司書',
    'Obadiah':          '俄巴底亞書',
    'Jonah':            '約拿書',
    'Micah':            '彌迦書',
    'Nahum':            '那鴻書',
    'Habakkuk':         '哈巴谷書',
    'Zephaniah':        '西番雅書',
    'Haggai':           '哈該書',
    'Zechariah':        '撒迦利亞書',
    'Malachi':          '瑪拉基書',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          '馬太福音',
    'Mark':             '馬可福音',
    'Luke':             '路加福音',
    'John':             '約翰福音',
    'Acts':             '使徒行傳',
    'Romans':           '羅馬書',
    '1 Corinthians':    '哥林多前書',
    '2 Corinthians':    '哥林多後書',
    'Galatians':        '加拉太書',
    'Ephesians':        '以弗所書',
    'Philippians':      '腓立比書',
    'Colossians':       '歌羅西書',
    '1 Thessalonians':  '帖撒羅尼迦前書',
    '2 Thessalonians':  '帖撒羅尼迦後書',
    '1 Timothy':        '提摩太前書',
    '2 Timothy':        '提摩太後書',
    'Titus':            '提多書',
    'Philemon':         '腓利門書',
    'Hebrews':          '希伯來書',
    'James':            '雅各書',
    '1 Peter':          '彼得前書',
    '2 Peter':          '彼得後書',
    '1 John':           '約翰一書',
    '2 John':           '約翰二書',
    '3 John':           '約翰三書',
    'Jude':             '猶大書',
    'Revelation':       '啟示錄',
  },

  ko: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          '창세기',
    'Exodus':           '출애굽기',
    'Leviticus':        '레위기',
    'Numbers':          '민수기',
    'Deuteronomy':      '신명기',
    'Joshua':           '여호수아',
    'Judges':           '사사기',
    'Ruth':             '룻기',
    '1 Samuel':         '사무엘상',
    '2 Samuel':         '사무엘하',
    '1 Kings':          '열왕기상',
    '2 Kings':          '열왕기하',
    '1 Chronicles':     '역대상',
    '2 Chronicles':     '역대하',
    'Ezra':             '에스라',
    'Nehemiah':         '느헤미야',
    'Esther':           '에스더',
    'Job':              '욥기',
    'Psalms':           '시편',
    'Proverbs':         '잠언',
    'Ecclesiastes':     '전도서',
    'Song of Solomon':  '아가',
    'Isaiah':           '이사야',
    'Jeremiah':         '예레미야',
    'Lamentations':     '예레미야애가',
    'Ezekiel':          '에스겔',
    'Daniel':           '다니엘',
    'Hosea':            '호세아',
    'Joel':             '요엘',
    'Amos':             '아모스',
    'Obadiah':          '오바댜',
    'Jonah':            '요나',
    'Micah':            '미가',
    'Nahum':            '나훔',
    'Habakkuk':         '하박국',
    'Zephaniah':        '스바냐',
    'Haggai':           '학개',
    'Zechariah':        '스가랴',
    'Malachi':          '말라기',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          '마태복음',
    'Mark':             '마가복음',
    'Luke':             '누가복음',
    'John':             '요한복음',
    'Acts':             '사도행전',
    'Romans':           '로마서',
    '1 Corinthians':    '고린도전서',
    '2 Corinthians':    '고린도후서',
    'Galatians':        '갈라디아서',
    'Ephesians':        '에베소서',
    'Philippians':      '빌립보서',
    'Colossians':       '골로새서',
    '1 Thessalonians':  '데살로니가전서',
    '2 Thessalonians':  '데살로니가후서',
    '1 Timothy':        '디모데전서',
    '2 Timothy':        '디모데후서',
    'Titus':            '디도서',
    'Philemon':         '빌레몬서',
    'Hebrews':          '히브리서',
    'James':            '야고보서',
    '1 Peter':          '베드로전서',
    '2 Peter':          '베드로후서',
    '1 John':           '요한일서',
    '2 John':           '요한이서',
    '3 John':           '요한삼서',
    'Jude':             '유다서',
    'Revelation':       '요한계시록',
  },

  it: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          'Genesi',
    'Exodus':           'Esodo',
    'Leviticus':        'Levitico',
    'Numbers':          'Numeri',
    'Deuteronomy':      'Deuteronomio',
    'Joshua':           'Giosuè',
    'Judges':           'Giudici',
    'Ruth':             'Rut',
    '1 Samuel':         '1 Samuele',
    '2 Samuel':         '2 Samuele',
    '1 Kings':          '1 Re',
    '2 Kings':          '2 Re',
    '1 Chronicles':     '1 Cronache',
    '2 Chronicles':     '2 Cronache',
    'Ezra':             'Esdra',
    'Nehemiah':         'Neemia',
    'Esther':           'Ester',
    'Job':              'Giobbe',
    'Psalms':           'Salmi',
    'Proverbs':         'Proverbi',
    'Ecclesiastes':     'Ecclesiaste',
    'Song of Solomon':  'Cantico dei Cantici',
    'Isaiah':           'Isaia',
    'Jeremiah':         'Geremia',
    'Lamentations':     'Lamentazioni',
    'Ezekiel':          'Ezechiele',
    'Daniel':           'Daniele',
    'Hosea':            'Osea',
    'Joel':             'Gioele',
    'Amos':             'Amos',
    'Obadiah':          'Abdia',
    'Jonah':            'Giona',
    'Micah':            'Michea',
    'Nahum':            'Naum',
    'Habakkuk':         'Abacuc',
    'Zephaniah':        'Sofonia',
    'Haggai':           'Aggeo',
    'Zechariah':        'Zaccaria',
    'Malachi':          'Malachia',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          'Matteo',
    'Mark':             'Marco',
    'Luke':             'Luca',
    'John':             'Giovanni',
    'Acts':             'Atti',
    'Romans':           'Romani',
    '1 Corinthians':    '1 Corinzi',
    '2 Corinthians':    '2 Corinzi',
    'Galatians':        'Galati',
    'Ephesians':        'Efesini',
    'Philippians':      'Filippesi',
    'Colossians':       'Colossesi',
    '1 Thessalonians':  '1 Tessalonicesi',
    '2 Thessalonians':  '2 Tessalonicesi',
    '1 Timothy':        '1 Timoteo',
    '2 Timothy':        '2 Timoteo',
    'Titus':            'Tito',
    'Philemon':         'Filemone',
    'Hebrews':          'Ebrei',
    'James':            'Giacomo',
    '1 Peter':          '1 Pietro',
    '2 Peter':          '2 Pietro',
    '1 John':           '1 Giovanni',
    '2 John':           '2 Giovanni',
    '3 John':           '3 Giovanni',
    'Jude':             'Giuda',
    'Revelation':       'Apocalisse',
  },

  ja: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          '創世記',
    'Exodus':           '出エジプト記',
    'Leviticus':        'レビ記',
    'Numbers':          '民数記',
    'Deuteronomy':      '申命記',
    'Joshua':           'ヨシュア記',
    'Judges':           '士師記',
    'Ruth':             'ルツ記',
    '1 Samuel':         'サムエル記上',
    '2 Samuel':         'サムエル記下',
    '1 Kings':          '列王紀上',
    '2 Kings':          '列王紀下',
    '1 Chronicles':     '歴代志上',
    '2 Chronicles':     '歴代志下',
    'Ezra':             'エズラ記',
    'Nehemiah':         'ネヘミヤ記',
    'Esther':           'エステル記',
    'Job':              'ヨブ記',
    'Psalms':           '詩篇',
    'Proverbs':         '箴言',
    'Ecclesiastes':     '伝道の書',
    'Song of Solomon':  '雅歌',
    'Isaiah':           'イザヤ書',
    'Jeremiah':         'エレミヤ書',
    'Lamentations':     '哀歌',
    'Ezekiel':          'エゼキエル書',
    'Daniel':           'ダニエル書',
    'Hosea':            'ホセア書',
    'Joel':             'ヨエル書',
    'Amos':             'アモス書',
    'Obadiah':          'オバデヤ書',
    'Jonah':            'ヨナ書',
    'Micah':            'ミカ書',
    'Nahum':            'ナホム書',
    'Habakkuk':         'ハバクク書',
    'Zephaniah':        'ゼパニヤ書',
    'Haggai':           'ハガイ書',
    'Zechariah':        'ゼカリヤ書',
    'Malachi':          'マラキ書',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          'マタイによる福音書',
    'Mark':             'マルコによる福音書',
    'Luke':             'ルカによる福音書',
    'John':             'ヨハネによる福音書',
    'Acts':             '使徒行伝',
    'Romans':           'ローマ人への手紙',
    '1 Corinthians':    'コリント人への第一の手紙',
    '2 Corinthians':    'コリント人への第二の手紙',
    'Galatians':        'ガラテヤ人への手紙',
    'Ephesians':        'エペソ人への手紙',
    'Philippians':      'ピリピ人への手紙',
    'Colossians':       'コロサイ人への手紙',
    '1 Thessalonians':  'テサロニケ人への第一の手紙',
    '2 Thessalonians':  'テサロニケ人への第二の手紙',
    '1 Timothy':        'テモテへの第一の手紙',
    '2 Timothy':        'テモテへの第二の手紙',
    'Titus':            'テトスへの手紙',
    'Philemon':         'ピレモンへの手紙',
    'Hebrews':          'ヘブル人への手紙',
    'James':            'ヤコブの手紙',
    '1 Peter':          'ペテロの第一の手紙',
    '2 Peter':          'ペテロの第二の手紙',
    '1 John':           'ヨハネの第一の手紙',
    '2 John':           'ヨハネの第二の手紙',
    '3 John':           'ヨハネの第三の手紙',
    'Jude':             'ユダの手紙',
    'Revelation':       'ヨハネの黙示録',
  },

  fr: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          'Genèse',
    'Exodus':           'Exode',
    'Leviticus':        'Lévitique',
    'Numbers':          'Nombres',
    'Deuteronomy':      'Deutéronome',
    'Joshua':           'Josué',
    'Judges':           'Juges',
    'Ruth':             'Ruth',
    '1 Samuel':         '1 Samuel',
    '2 Samuel':         '2 Samuel',
    '1 Kings':          '1 Rois',
    '2 Kings':          '2 Rois',
    '1 Chronicles':     '1 Chroniques',
    '2 Chronicles':     '2 Chroniques',
    'Ezra':             'Esdras',
    'Nehemiah':         'Néhémie',
    'Esther':           'Esther',
    'Job':              'Job',
    'Psalms':           'Psaumes',
    'Proverbs':         'Proverbes',
    'Ecclesiastes':     'Ecclésiaste',
    'Song of Solomon':  'Cantique des cantiques',
    'Isaiah':           'Ésaïe',
    'Jeremiah':         'Jérémie',
    'Lamentations':     'Lamentations',
    'Ezekiel':          'Ézéchiel',
    'Daniel':           'Daniel',
    'Hosea':            'Osée',
    'Joel':             'Joël',
    'Amos':             'Amos',
    'Obadiah':          'Abdias',
    'Jonah':            'Jonas',
    'Micah':            'Michée',
    'Nahum':            'Nahum',
    'Habakkuk':         'Habacuc',
    'Zephaniah':        'Sophonie',
    'Haggai':           'Aggée',
    'Zechariah':        'Zacharie',
    'Malachi':          'Malachie',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          'Matthieu',
    'Mark':             'Marc',
    'Luke':             'Luc',
    'John':             'Jean',
    'Acts':             'Actes',
    'Romans':           'Romains',
    '1 Corinthians':    '1 Corinthiens',
    '2 Corinthians':    '2 Corinthiens',
    'Galatians':        'Galates',
    'Ephesians':        'Éphésiens',
    'Philippians':      'Philippiens',
    'Colossians':       'Colossiens',
    '1 Thessalonians':  '1 Thessaloniciens',
    '2 Thessalonians':  '2 Thessaloniciens',
    '1 Timothy':        '1 Timothée',
    '2 Timothy':        '2 Timothée',
    'Titus':            'Tite',
    'Philemon':         'Philémon',
    'Hebrews':          'Hébreux',
    'James':            'Jacques',
    '1 Peter':          '1 Pierre',
    '2 Peter':          '2 Pierre',
    '1 John':           '1 Jean',
    '2 John':           '2 Jean',
    '3 John':           '3 Jean',
    'Jude':             'Jude',
    'Revelation':       'Apocalypse',
  },

  de: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          '1. Mose',
    'Exodus':           '2. Mose',
    'Leviticus':        '3. Mose',
    'Numbers':          '4. Mose',
    'Deuteronomy':      '5. Mose',
    'Joshua':           'Josua',
    'Judges':           'Richter',
    'Ruth':             'Ruth',
    '1 Samuel':         '1. Samuel',
    '2 Samuel':         '2. Samuel',
    '1 Kings':          '1. Könige',
    '2 Kings':          '2. Könige',
    '1 Chronicles':     '1. Chronik',
    '2 Chronicles':     '2. Chronik',
    'Ezra':             'Esra',
    'Nehemiah':         'Nehemia',
    'Esther':           'Esther',
    'Job':              'Hiob',
    'Psalms':           'Psalmen',
    'Proverbs':         'Sprüche',
    'Ecclesiastes':     'Prediger',
    'Song of Solomon':  'Hohelied',
    'Isaiah':           'Jesaja',
    'Jeremiah':         'Jeremia',
    'Lamentations':     'Klagelieder',
    'Ezekiel':          'Hesekiel',
    'Daniel':           'Daniel',
    'Hosea':            'Hosea',
    'Joel':             'Joel',
    'Amos':             'Amos',
    'Obadiah':          'Obadja',
    'Jonah':            'Jona',
    'Micah':            'Micha',
    'Nahum':            'Nahum',
    'Habakkuk':         'Habakuk',
    'Zephaniah':        'Zefanja',
    'Haggai':           'Haggai',
    'Zechariah':        'Sacharja',
    'Malachi':          'Maleachi',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          'Matthäus',
    'Mark':             'Markus',
    'Luke':             'Lukas',
    'John':             'Johannes',
    'Acts':             'Apostelgeschichte',
    'Romans':           'Römer',
    '1 Corinthians':    '1. Korinther',
    '2 Corinthians':    '2. Korinther',
    'Galatians':        'Galater',
    'Ephesians':        'Epheser',
    'Philippians':      'Philipper',
    'Colossians':       'Kolosser',
    '1 Thessalonians':  '1. Thessalonicher',
    '2 Thessalonians':  '2. Thessalonicher',
    '1 Timothy':        '1. Timotheus',
    '2 Timothy':        '2. Timotheus',
    'Titus':            'Titus',
    'Philemon':         'Philemon',
    'Hebrews':          'Hebräer',
    'James':            'Jakobus',
    '1 Peter':          '1. Petrus',
    '2 Peter':          '2. Petrus',
    '1 John':           '1. Johannes',
    '2 John':           '2. Johannes',
    '3 John':           '3. Johannes',
    'Jude':             'Judas',
    'Revelation':       'Offenbarung',
  },

  es: {
    // ── Old Testament ────────────────────────────────────────────────────────
    'Genesis':          'Génesis',
    'Exodus':           'Éxodo',
    'Leviticus':        'Levítico',
    'Numbers':          'Números',
    'Deuteronomy':      'Deuteronomio',
    'Joshua':           'Josué',
    'Judges':           'Jueces',
    'Ruth':             'Rut',
    '1 Samuel':         '1 Samuel',
    '2 Samuel':         '2 Samuel',
    '1 Kings':          '1 Reyes',
    '2 Kings':          '2 Reyes',
    '1 Chronicles':     '1 Crónicas',
    '2 Chronicles':     '2 Crónicas',
    'Ezra':             'Esdras',
    'Nehemiah':         'Nehemías',
    'Esther':           'Ester',
    'Job':              'Job',
    'Psalms':           'Salmos',
    'Proverbs':         'Proverbios',
    'Ecclesiastes':     'Eclesiastés',
    'Song of Solomon':  'Cantares',
    'Isaiah':           'Isaías',
    'Jeremiah':         'Jeremías',
    'Lamentations':     'Lamentaciones',
    'Ezekiel':          'Ezequiel',
    'Daniel':           'Daniel',
    'Hosea':            'Oseas',
    'Joel':             'Joel',
    'Amos':             'Amós',
    'Obadiah':          'Abdías',
    'Jonah':            'Jonás',
    'Micah':            'Miqueas',
    'Nahum':            'Nahúm',
    'Habakkuk':         'Habacuc',
    'Zephaniah':        'Sofonías',
    'Haggai':           'Hageo',
    'Zechariah':        'Zacarías',
    'Malachi':          'Malaquías',
    // ── New Testament ────────────────────────────────────────────────────────
    'Matthew':          'Mateo',
    'Mark':             'Marcos',
    'Luke':             'Lucas',
    'John':             'Juan',
    'Acts':             'Hechos',
    'Romans':           'Romanos',
    '1 Corinthians':    '1 Corintios',
    '2 Corinthians':    '2 Corintios',
    'Galatians':        'Gálatas',
    'Ephesians':        'Efesios',
    'Philippians':      'Filipenses',
    'Colossians':       'Colosenses',
    '1 Thessalonians':  '1 Tesalonicenses',
    '2 Thessalonians':  '2 Tesalonicenses',
    '1 Timothy':        '1 Timoteo',
    '2 Timothy':        '2 Timoteo',
    'Titus':            'Tito',
    'Philemon':         'Filemón',
    'Hebrews':          'Hebreos',
    'James':            'Santiago',
    '1 Peter':          '1 Pedro',
    '2 Peter':          '2 Pedro',
    '1 John':           '1 Juan',
    '2 John':           '2 Juan',
    '3 John':           '3 Juan',
    'Jude':             'Judas',
    'Revelation':       'Apocalipsis',
  },
};

/**
 * Returns the localized book name for the given language.
 * Falls back to the original name if no translation is found.
 * zh-s (Simplified Chinese) shares book names with zh (Traditional Chinese).
 */
export function localizeBookName(englishName, language) {
  const lang = language === 'zh-s' ? 'zh' : language;
  return BOOK_NAMES[lang]?.[englishName] ?? englishName;
}

/**
 * Mapping of English book names to 3-letter codes used by HelloAO API.
 */
export const HELLOAO_BOOK_CODES = {
  'Genesis': 'GEN', 'Exodus': 'EXO', 'Leviticus': 'LEV', 'Numbers': 'NUM', 'Deuteronomy': 'DEU',
  'Joshua': 'JOS', 'Judges': 'JDG', 'Ruth': 'RUT', '1 Samuel': '1SA', '2 Samuel': '2SA',
  '1 Kings': '1KI', '2 Kings': '2KI', '1 Chronicles': '1CH', '2 Chronicles': '2CH',
  'Ezra': 'EZR', 'Nehemiah': 'NEH', 'Esther': 'EST', 'Job': 'JOB', 'Psalms': 'PSA',
  'Proverbs': 'PRO', 'Ecclesiastes': 'ECC', 'Song of Solomon': 'SNG', 'Isaiah': 'ISA',
  'Jeremiah': 'JER', 'Lamentations': 'LAM', 'Ezekiel': 'EZK', 'Daniel': 'DAN',
  'Hosea': 'HOS', 'Joel': 'JOL', 'Amos': 'AMO', 'Obadiah': 'OBD', 'Jonah': 'JON',
  'Micah': 'MIC', 'Nahum': 'NAM', 'Habakkuk': 'HAB', 'Zephaniah': 'ZEP', 'Haggai': 'HAG',
  'Zechariah': 'ZEC', 'Malachi': 'MAL', 'Matthew': 'MAT', 'Mark': 'MRK', 'Luke': 'LUK',
  'John': 'JHN', 'Acts': 'ACT', 'Romans': 'ROM', '1 Corinthians': '1CO', '2 Corinthians': '2CO',
  'Galatians': 'GAL', 'Ephesians': 'EPH', 'Philippians': 'PHP', 'Colossians': 'COL',
  '1 Thessalonians': '1TH', '2 Thessalonians': '2TH', '1 Timothy': '1TI', '2 Timothy': '2TI',
  'Titus': 'TIT', 'Philemon': 'PHM', 'Hebrews': 'HEB', 'James': 'JAS', '1 Peter': '1PE',
  '2 Peter': '2PE', '1 John': '1JN', '2 John': '2JN', '3 John': '3JN', 'Jude': 'JUD',
  'Revelation': 'REV'
};
